(() => {
  'use strict';
  const root = document.querySelector('[data-nt-announce]');
  if (!root) return;
  const track = root.querySelector('[data-slides]');
  const originals = track ? [...track.querySelectorAll('[data-slide]')] : [];
  if (!track || originals.length <= 1) return;

  const TRANSITION_MS = 500;

  // Clone first slide → end, clone last slide → beginning, for infinite-loop illusion.
  const firstClone = originals[0].cloneNode(true);
  const lastClone = originals[originals.length - 1].cloneNode(true);
  firstClone.setAttribute('data-clone', 'true');
  lastClone.setAttribute('data-clone', 'true');
  firstClone.setAttribute('aria-hidden', 'true');
  lastClone.setAttribute('aria-hidden', 'true');
  track.appendChild(firstClone);
  track.insertBefore(lastClone, originals[0]);

  const slides = [...track.querySelectorAll('[data-slide]')];
  let i = 1; // Start at first real slide (index 0 is the prepended clone).
  let animating = false;

  function setPosition(idx, animate) {
    if (animate === false) {
      track.style.transition = 'none';
      track.style.transform = `translateX(-${idx * 100}%)`;
      // Force reflow so the next transition isn't batched with this set.
      void track.offsetWidth;
      track.style.transition = '';
    } else {
      track.style.transform = `translateX(-${idx * 100}%)`;
    }
  }

  // Initial position (no animation).
  setPosition(i, false);

  function step(delta) {
    if (animating) return;
    animating = true;
    i += delta;
    setPosition(i, true);
    setTimeout(() => {
      // If we landed on a clone, jump silently to its real twin.
      if (i === slides.length - 1) {
        i = 1;
        setPosition(i, false);
      } else if (i === 0) {
        i = slides.length - 2;
        setPosition(i, false);
      }
      animating = false;
    }, TRANSITION_MS);
  }

  root.querySelector('[data-next]')?.addEventListener('click', () => step(1));
  root.querySelector('[data-prev]')?.addEventListener('click', () => step(-1));
})();
